import React from 'react'
import {Checkbox, FormControlLabel} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const FEmailField = ({data, onChange = (e, key, value) => {}}) => {
  return (
    <>
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e => onChange(e, 'allow_scanning', !(data?.allow_scanning || false))}
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.allow_scanning || false}
            name="required"
          />
        }
        label="Bar Code Scanner?"
      />
    </>
  )
}

export default FEmailField
